const colorectalPath=[
    {
    label:"Has the patient been given FIT tests",
    controlType:"radio button",
    options:["Issued-results available", "Issued- results awaited", "Not issued"]
    },

    {
    label:"Do you feel the patient would cope with taking strong laxatives for bowel prep?",
    controlType:"radio button",
    options:["Yes", "No", "Unsure"]
    },

    ]
export default colorectalPath
   

